
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        @Prop()
        public Publicacion: Publicacion;
        public Cargando: boolean = false;
        async mounted()
        {
            if ( !this.Publicacion.Descripcion )
            {
                this.Cargando = true;
                await Wait( 1000 );
                await this.Publicacion.CargarDescripcion();
                this.Cargando = false;
            }

        }
    }
